const CHAT_API_ROUTE = `${process.env.REACT_APP_CHAT_API_ROUTE}`;

const AUDIT_API_ROUTE = `${CHAT_API_ROUTE}/audit`;
export const GET_AUDITS_API_ROUTE = `${AUDIT_API_ROUTE}/get-audits-by-tags`;